import { render, staticRenderFns } from "./FormSubmissionsPage.vue?vue&type=template&id=1121f393&scoped=true"
import script from "./FormSubmissionsPage.vue?vue&type=script&lang=js"
export * from "./FormSubmissionsPage.vue?vue&type=script&lang=js"
import style0 from "./FormSubmissionsPage.vue?vue&type=style&index=0&id=1121f393&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1121f393",
  null
  
)

export default component.exports